import { isNotUndefined } from 'infrastructure/functions';

import {
  additionalFollowUpText,
  compareToLastReview,
  croOrDncText,
  reviewedReadings,
  needEscalateText,
  uniqueDaysTextWithType,
  waitingDeviceReplacement,
} from '../helpers';

import type { TMaWeightYellowDataOptional } from '../../types';

export const weight = (data: TMaWeightYellowDataOptional) => {
  let text = '';

  const weightReasonText = 'Patient is on weight monitoring for';
  if (isNotUndefined(data.weightReason) && data.weightReason !== 'other') {
    text += `${weightReasonText} ${data.weightReason}. `;
    if (data.weightReasonComment?.trim())
      text += `${data.weightReasonComment}. `;
  }
  if (data.weightReasonComment?.trim())
    text += `${weightReasonText} ${data.weightReasonComment}. `;

  const waitingDeviceReplacementText = waitingDeviceReplacement(
    data.waitingDeviceReplacement,
    data.waitingForDeviceReplacementList,
  );
  if (waitingDeviceReplacementText.trim())
    text += `\n${waitingDeviceReplacementText}`;
  if (data.waitingForDeviceReplacementComment?.trim()) {
    if (data.waitingDeviceReplacement === undefined) text += '\n';
    text += `${data.waitingForDeviceReplacementComment}. `;
  }

  if (isNotUndefined(data.didPatientReportWeight)) {
    text += '\n';
    text += `Patient ${
      data.didPatientReportWeight ? 'reported' : 'did not report'
    } any difficulties with weight readings since the last call. `;
  }
  if (data.didPatientReportWeightComment?.trim()) {
    if (data.didPatientReportWeight === undefined) text += '\n';
    text += `${data.didPatientReportWeightComment}. `;
  }

  const maReviewedReadingsText = reviewedReadings({
    template: 'MA',
    type: 'weight',
    atRiskNumber: data.atRiskNumber,
    thresholds: [
      {
        name: 'weight',
        lowValue: data.lowestWeight,
        highValue: data.highestWeight,
      },
    ],
  });
  if (maReviewedReadingsText.trim()) text += `\n${maReviewedReadingsText}`;

  let trend = '';
  if (data.typeofTrend === 'high') {
    trend = 'High ';
  }
  if (data.typeofTrend === 'low') {
    trend = 'Low ';
  }
  if (data.typeofTrend === 'both') {
    trend = 'Both ';
  }
  if (data.typeofTrend === 'other' && data.otherTypeofTrend?.trim()) {
    trend = data.otherTypeofTrend.trim();
  }
  if (trend) {
    text += '\n';
    text += `${trend} trends noted for patient’s weight readings. `;
  }

  const comparedToLastReviewText = compareToLastReview(
    data.comparedToLastReview,
    data.comparedToLastReviewTrend,
  );
  if (comparedToLastReviewText.trim()) text += `\n${comparedToLastReviewText}`;

  if (isNotUndefined(data.uniqueDays)) {
    text += '\n';
    text += uniqueDaysTextWithType('weight', data.uniqueDays);
  }

  if (croOrDncText(data).trim()) text += `\n${croOrDncText(data)}`;

  if (additionalFollowUpText(data).trim())
    text += `\n${additionalFollowUpText(data)}`;

  if (needEscalateText(data).trim()) text += `\n${needEscalateText(data)}`;

  if (data.freeTextComments?.trim()) text += `\n${data.freeTextComments}. `;

  return text;
};
